import { useEffect, useState } from "react";

const POPUP_DELAY_MS = 5000;
const POPUP_DISMISSED_KEY = "df26_popup_dismissed";

export function useDreamforceCampaign() {
  const [showBanner, setShowBanner] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Banner dismissal is intentionally not persisted, so it reappears on every page refresh.
    setShowBanner(true);

    const popupDismissed = sessionStorage.getItem(POPUP_DISMISSED_KEY) === "1";
    if (popupDismissed) return;

    const timer = setTimeout(() => setShowPopup(true), POPUP_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const closeBanner = () => {
    setShowBanner(false);
  };

  const closePopup = () => {
    setShowPopup(false);
    sessionStorage.setItem(POPUP_DISMISSED_KEY, "1");
  };

  const openPopupNow = () => setShowPopup(true);

  return { showBanner, showPopup, closeBanner, closePopup, openPopupNow };
}
